import * as React from 'react';
export const idahocentralSvg = React.forwardRef(function idahocentralSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#25B14A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.965 14.655 18.38 4.25h1.694L7.865 16.459c-.032-.605 0-1.21.1-1.804Zm9.547-6.676a6.608 6.608 0 0 0-.65-.1L3.247 21.487h1.705l13.33-13.32a6.044 6.044 0 0 0-.77-.187Zm-4.906.605a8.032 8.032 0 0 0-1.782 1.122L2.85 17.669h1.639l9.657-9.602a8.18 8.18 0 0 0-1.54.517Zm2.53 19.666h-1.694l10.515-10.504a8.06 8.06 0 0 1-.737 2.035 8.5 8.5 0 0 1-.703 1.067l-7.38 7.402Zm4.939-19.314L4.62 24.378h1.716l14.76-14.75a9.135 9.135 0 0 0-1.011-.692h-.011ZM8.537 26.402H6.832l15.53-15.53c.254.33.485.66.694 1.011l-14.52 14.52ZM9.79 27.7h1.694l12.627-12.627a9.008 9.008 0 0 0-.286-1.419L9.79 27.7ZM22.055 4.822 8.284 18.582c.132.407.308.814.506 1.199L23.76 4.822h-1.705Zm-6.589 19.292 11.22-11.208h1.693L17.25 24.037a8.064 8.064 0 0 1-1.783.077ZM26.421 8.936 12.166 23.19c.385.21.781.374 1.188.517l14.761-14.76h-1.694v-.011ZM9.823 21.299 25.035 6.087h1.705l-16.059 16.07a8.214 8.214 0 0 1-.858-.858Z',
      fill: '#FEFEFE',
    }),
  );
});
idahocentralSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var idahocentral = {
  category: 'brand',
  colorable: false,
  name: 'idahocentral',
  svg: idahocentralSvg,
};
